module.exports = __webpack_public_path__ + "p4_img5.jpg?e55854187df8e2ced3ae375674c54a33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img5.jpg
// module id = 112
// module chunks = 0